import React from 'react';
import css from './style.module.css';

const Center = ({ id = "", className = false, children, style = {} }) => {
    return (
        <div id={id} className={`${css.center}${className ? " " + className : ""}`} style={style}>{children}</div>
    )
}

export default Center;